"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Label = _interopRequireDefault(require("../../Label"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _utils = _interopRequireDefault(require("../../utils/utils"));

var _fileUtils = _interopRequireDefault(require("../../utils/fileUtils"));

var _UploadItem = _interopRequireDefault(require("./UploadItem.style"));

var _Button = _interopRequireDefault(require("../../Button"));

var _Stack = _interopRequireDefault(require("../../Stack"));

var _ProgressBar = _interopRequireDefault(require("../../ProgressBar"));

var _cr = _interopRequireDefault(require("../../utils/cr"));

var _Space = _interopRequireDefault(require("../../Space"));

var _corezoid_light = _interopRequireDefault(require("../../themes/corezoid_light"));

var _dec, _class, _class2, _temp;

let UploadItem = (_dec = (0, _reactJss.default)(_UploadItem.default), _dec(_class = (_temp = _class2 = class UploadItem extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.removeFile = this.removeFile.bind(this);
  }

  removeFile() {
    const {
      onRemove,
      id
    } = this.props;
    onRemove(id);
  }

  renderPortalImg() {
    const {
      type,
      classes,
      label,
      value
    } = this.props;

    if (type.indexOf('image') === -1) {
      return /*#__PURE__*/_react.default.createElement(_Icon.default, {
        type: 'attach'
      });
    }

    return /*#__PURE__*/_react.default.createElement("img", {
      className: classes.chipImg,
      alt: label,
      src: value
    });
  }

  renderDefaultImg() {
    const {
      type,
      classes,
      label,
      value
    } = this.props;
    if (type.indexOf('image') === -1) return null;
    return /*#__PURE__*/_react.default.createElement("img", {
      className: classes.fileImg,
      alt: label,
      src: value
    });
  } // превью во внешнем потрале


  renderPortal() {
    const {
      classes,
      className,
      id,
      label,
      error,
      size,
      maxFileSizeErrorText,
      maxFileSize,
      closeIcon,
      onClick: _onClick,
      dataTestId
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      onClick: () => _onClick(id),
      className: (0, _clsx.default)(className, classes.fileItemChip, 'fileItemChip', {
        error
      }),
      "data-testid": dataTestId
    }, this.renderPortalImg(), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.chipTextBox
    }, /*#__PURE__*/_react.default.createElement(_Label.default, {
      value: label,
      textColor: 'inherit',
      className: classes.chipText
    }), /*#__PURE__*/_react.default.createElement(_Label.default, {
      fontSize: 'small',
      value: error ? `${maxFileSizeErrorText} ${_fileUtils.default.biteToSize(maxFileSize)}` : `${_fileUtils.default.biteToSize(size)}`,
      visibility: error ? 'visible' : 'disabled',
      className: classes.chipHelperText
    })), closeIcon ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
      type: "close",
      size: "small",
      color: 'currentColor',
      className: (0, _clsx.default)(classes.delFileIcon),
      onClick: this.removeFile
    }) : null);
  } // превью по умолчанию


  renderDefault() {
    const {
      classes,
      className,
      id,
      label,
      size,
      closeIcon,
      onClick: _onClick2,
      dataTestId
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      className: (0, _clsx.default)(className, classes.fileItem),
      onClick: () => _onClick2(id),
      "data-testid": dataTestId
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.fileItemInfo
    }, /*#__PURE__*/_react.default.createElement(_Label.default, {
      value: label,
      fontWeight: "semibold"
    }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_Label.default, {
      value: `File size: ${_fileUtils.default.biteToSize(size)}`,
      fontSize: "small"
    }), /*#__PURE__*/_react.default.createElement("br", null), this.renderDefaultImg()), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.fileItemControls
    }, closeIcon ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: classes.delFileBtn,
      type: "close",
      size: "small",
      onClick: this.removeFile
    }) : null));
  }

  getVariables(uploadingStatus, classes) {
    switch (uploadingStatus) {
      case UploadItem.STATUSES.DONE:
        return {
          progressLineValue: classes.done,
          textColor: UploadItem.doneColor,
          iconColor: UploadItem.doneColor,
          iconType: 'check',
          controlButtonType: 'close'
        };

      case UploadItem.STATUSES.ERROR:
        return {
          progressLineValue: classes.error,
          textColor: UploadItem.errorColor,
          iconColor: UploadItem.errorColor,
          iconType: 'declined',
          controlButtonType: 'repeat'
        };

      default:
        return {
          progressLineValue: '',
          textColor: '',
          iconColor: '',
          iconType: '',
          controlButtonType: 'close'
        };
    }
  }

  renderUploadProgress() {
    const {
      uploadingFile,
      uploadingFileIcon,
      classes,
      fullWidth,
      bordered,
      dataTestId
    } = this.props;
    if (!uploadingFile) return null;
    const {
      uploadProgress,
      fileName,
      textValue,
      uploadingStatus,
      retryFileUpload,
      removeFileUpload
    } = uploadingFile;
    const {
      textColor,
      iconColor,
      iconType,
      progressLineValue,
      controlButtonType
    } = this.getVariables(uploadingStatus, classes);
    return /*#__PURE__*/_react.default.createElement(_Stack.default.H, {
      fullWidth: fullWidth,
      className: bordered ? classes.bordered : '',
      justifyContent: "spaceBetween",
      dataTestId: dataTestId
    }, /*#__PURE__*/_react.default.createElement(_Stack.default.H, null, (0, _cr.default)([uploadingFileIcon, /*#__PURE__*/_react.default.createElement(_Space.default, {
      left: true,
      right: true,
      size: "micro"
    }, /*#__PURE__*/_react.default.createElement(_Stack.default, {
      fullWidth: true,
      fullHeight: true,
      alignItems: "center",
      justifyContent: "center"
    }, uploadingFileIcon))]), /*#__PURE__*/_react.default.createElement(_Stack.default.V, {
      fullHeight: true,
      size: "xxsmall",
      style: {
        flexWrap: 'nowrap'
      }
    }, /*#__PURE__*/_react.default.createElement(_Stack.default.H, {
      style: {
        flexWrap: 'nowrap'
      },
      fullWidth: true,
      justifyContent: "spaceBetween",
      className: classes.uploadProgressBar
    }, /*#__PURE__*/_react.default.createElement(_Label.default, {
      overflow: "cut",
      fontSize: "small",
      value: fileName,
      className: uploadingStatus === UploadItem.STATUSES.ERROR ? classes.errorTetxt : ''
    }), /*#__PURE__*/_react.default.createElement(_Stack.default.H, {
      size: "xxsmall"
    }, (0, _cr.default)([iconType, /*#__PURE__*/_react.default.createElement(_Stack.default, {
      fullWidth: true,
      fullHeight: true,
      alignItems: "center",
      justifyContent: "center"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      size: "small",
      type: iconType,
      color: iconColor
    }))]), /*#__PURE__*/_react.default.createElement(_Label.default, {
      style: {
        whiteSpace: 'nowrap'
      },
      fontSize: "small",
      value: textValue,
      textColor: textColor
    }))), /*#__PURE__*/_react.default.createElement(_Stack.default.H, {
      fullWidth: true
    }, /*#__PURE__*/_react.default.createElement(_ProgressBar.default, {
      classes: {
        progressLine: progressLineValue
      },
      className: classes.uploadProgressBarStaus,
      type: "line",
      size: "xlarge",
      value: uploadProgress,
      showValue: false
    })))), /*#__PURE__*/_react.default.createElement(_Button.default, {
      icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
        size: "small",
        type: controlButtonType,
        className: classes.controlButtons,
        onClick: () => {
          if (uploadingStatus === UploadItem.STATUSES.ERROR) {
            if (retryFileUpload) {
              retryFileUpload();
            }
          } else if (removeFileUpload) {
            removeFileUpload();
          }
        }
      }),
      type: "text",
      colorType: "gray"
    }));
  }

  render() {
    const {
      viewType
    } = this.props;
    return this[`render${_utils.default.toUpperLatter(viewType)}`]();
  }

}, (0, _defineProperty2.default)(_class2, "STATUSES", {
  DONE: 'done',
  UPLOADING: 'uploading',
  ERROR: 'error'
}), (0, _defineProperty2.default)(_class2, "doneColor", _corezoid_light.default.upload.doneColor), (0, _defineProperty2.default)(_class2, "errorColor", _corezoid_light.default.upload.errorColor), _temp)) || _class);
UploadItem.defaultProps = {
  closeIcon: true,
  visibility: 'visible',
  viewType: 'default',
  maxFileSize: null,
  onRemove: () => {},
  onClick: () => {},
  maxFileSizeErrorText: '',
  error: false
};
var _default = UploadItem;
exports.default = _default;